module.exports = __webpack_public_path__ + "static/img/18079AK_2_3_4_R_20191203_LC.671ac94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18079AK_2_3_4_R_20191203_LC.png
// module id = 1OaR
// module chunks = 0